export const COLOR_PALETTE = [
    '#B0B0B0', '#4CAF50', '#2196F3', '#A0522D', '#A1887F',
    '#C0C0C0', '#9C27B0', '#FF9800', '#00BCD4', '#8BC34A',
    '#E91E63', '#3F51B5', '#CDDC39', '#FFC107', '#795548',
    '#607D8B', '#F44336', '#673AB7', '#009688', '#FF5722',
    '#1ABC9C', '#2ECC71', '#3498DB', '#9B59B6', '#34495E',
    '#16A085', '#27AE60', '#2980B9', '#8E44AD', '#2C3E50',
    '#F1C40F', '#E67E22', '#E74C3C', '#ECF0F1', '#95A5A6',
    '#D35400', '#C0392B', '#BDC3C7', '#7F8C8D', '#FFEB3B',
    '#FFCDD2', '#C5CAE9', '#B2DFDB', '#DCEDC8', '#FFF9C4',
    '#D1C4E9', '#B3E5FC', '#FFCCBC', '#CFD8DC', '#F8BBD0',
    '#AED581', '#81D4FA', '#CE93D8', '#FFAB91', '#212121'
];

export const SPACER_VALUE = 0.1;